import { Injectable } from '@angular/core';

export enum LayoutEnum {
  FULL_NAV = 0,
  SMALL_NAV = 1
}

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  public currentLayout: LayoutEnum = LayoutEnum.FULL_NAV;

  public isFullscreen: boolean = false;

  set fullScreen(mode: boolean) {
    this.isFullscreen = mode;
  }

  get isExtended(): boolean {
    return this.currentLayout === LayoutEnum.FULL_NAV;
  }

  set extendedMode(mode: boolean) {
    mode ? this.currentLayout = LayoutEnum.FULL_NAV : this.currentLayout = LayoutEnum.SMALL_NAV;
  }

  constructor() { }

  updateLayout(newLayout: LayoutEnum) {
    this.currentLayout = newLayout;
  }
}
